import { render, staticRenderFns } from "./ChapterIndicators.vue?vue&type=template&id=01f5feb4&scoped=true&"
import script from "./ChapterIndicators.vue?vue&type=script&lang=js&"
export * from "./ChapterIndicators.vue?vue&type=script&lang=js&"
import style0 from "./ChapterIndicators.vue?vue&type=style&index=0&id=01f5feb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f5feb4",
  null
  
)

export default component.exports